$(document).ready(function () {

    //change variant names
    // $("input[value='Chocolate Chip']").next().text("CC").append("<span class='variant-full-name'>Chocolate Chip</span>");    
    // $("input[value='Birthday Cake']").next().text("BC").append("<span class='variant-full-name'>Birthday Cake</span>");    
    // $("input[value='Chocolate Brownie']").next().text("CB").append("<span class='variant-full-name'>Chocolate Brownie</span>");   
    // $("input[value='Oatmeal Chocolate Chip']").next().text("OCC").append("<span class='variant-full-name'>Oatmeal Chocolate Chip</span>"); 
    // $("input[value='Snickerdoodle']").next().text("SD").append("<span class='variant-full-name'>Snickerdoodle</span>");  

	
  
  //open external links in new tab
	var links = document.links;
	for (let i = 0, linksLength = links.length; i < linksLength; i++) {
		if (links[i].hostname !== window.location.hostname) {
			links[i].target = '_blank';
			links[i].rel = 'noreferrer noopener';
		}
	}

	// Add smooth scrolling
	var hashTagActive = "";
	$(".smooth-scroll").on("click touchstart", function (event) {
		if (hashTagActive != this.hash) { //this will prevent if the user click several times the same link to freeze the scroll.
			event.preventDefault();
			//calculate destination place
			var dest = 0;
			if ($(this.hash).offset().top > $(document).height() - $(window).height()) {
				dest = $(document).height() - $(window).height();
			} else {
				dest = $(this.hash).offset().top;
			}
			//go to destination
			$('html,body').animate({
				scrollTop: dest
			}, 2000, 'swing');
			hashTagActive = this.hash;

			//close menu
			$("#Details-menu-drawer-container").removeClass("menu-opening").removeAttr("open");
		}
	});

    // if (window.location.href.indexOf("?shop") > -1) {
    //   $(".top-image-row").hide();
    // }
      $(".show-labels-text").click(function (){
        $(this).hide();        
        $("img.labels-graphic").slideDown();        
      });



});